const truncate = (text, length) => {
  return text.length > length ? `${text.slice(0, length)} ...` : text
}

const TrucatedText = ({ text, length }) => truncate(text, length)

export default TrucatedText
